import React from 'react'
import { Menu as MuiMenu } from '@mui/material'
import type { MenuProps as MuiMenuProps } from '@mui/material'

const Menu = ({ children, open, ...menuProps }: MuiMenuProps) => {
	return (
		<MuiMenu open={open} {...menuProps}>
			{children}
		</MuiMenu>
	)
}

export default Menu
